/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 * THIS FILE IS AN AUTOGENERATED TYPESCRIPT PROXY EXTENSION.
 * TO USE THIS FILE, IT MUST BE ADDED TO A D365COMMERCE APPLICATION
 */
import {
    AsyncResult,
    callActionOrExecute,
    DataServiceQuery,
    IContext,
    IDataServiceRequest,
    IQueryResultSettings,
    // @ts-ignore -- Unused import
    NullResult
} from '@msdyn365-commerce/retail-proxy';
// @ts-ignore -- Unused import
import * as EntityClasses from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceModels.g';
// @ts-ignore -- Unused import
import * as Entities from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceTypes.g';
import * as DataServiceEntities from './DataServiceEntities.g';

// @ts-ignore
function vSIAddChargeQuery(id?: number): DataServiceQuery {
    const key = id ? { Id: id } : null;
    return new DataServiceQuery(
        'VSIAddCharge',
        'VSIRestAPIHandlerCharges',
        DataServiceEntities.VSIRestAPIHandlerChargesExtensionClass,
        key
    );
}

function vSIRemoveChargeQuery(id?: number): DataServiceQuery {
    const key = id ? { Id: id } : null;
    return new DataServiceQuery(
        'VSIRemoveCharges',
        'VSIRestAPIHandlerCharges',
        DataServiceEntities.VSIRestAPIHandlerChargesExtensionClass,
        key
    );
}

export function createVSI_AddChargeInput(cartId: string, moduleTypeValue: number, chargeCode: string, amount: number): IDataServiceRequest {
    const query = vSIAddChargeQuery();
    return query.createDataServiceRequestForOperation(
        'VSI_AddCharge',
        true,
        EntityClasses.CartClass,
        'false',
        { bypassCache: 'get', returnEntity: 'Entities.Cart' },
        { cartId: cartId, moduleTypeValue: moduleTypeValue, chargeCode: chargeCode, amount: amount }
    );
}

export function vSI_AddChargeAsync(
    context: IContext,
    cartId: string,
    moduleTypeValue: number,
    chargeCode: string,
    amount: number
): AsyncResult<Entities.Cart> {
    const request = createVSI_AddChargeInput(cartId, moduleTypeValue, chargeCode, amount);
    return callActionOrExecute<Entities.Cart>(request, context.callerContext);
}

export function createVSI_RemoveAllChargesInput(cartId: string): IDataServiceRequest {
    const query = vSIRemoveChargeQuery();
    return query.createDataServiceRequestForOperation(
        'VSI_RemoveAllCharges',
        true,
        EntityClasses.CartClass,
        'false',
        { bypassCache: 'get', returnEntity: 'Entities.Cart' },
        { cartId: cartId }
    );
}

export function vSI_RemoveAllChargesAsync(context: IContext, cartId: string): AsyncResult<Entities.Cart> {
    const request = createVSI_RemoveAllChargesInput(cartId);
    return callActionOrExecute<Entities.Cart>(request, context.callerContext);
}

// @ts-ignore
function vSIGetRestAPIResponseQuery(id?: number): DataServiceQuery {
    const key = id ? { Id: id } : null;
    return new DataServiceQuery('VSIGetRestAPIResponse', 'VSIRestAPIHandler', DataServiceEntities.VSIRestAPIHandlerExtensionClass, key);
}

export function createVSI_CallGenericRestAPIHandlerInput(
    targetSystem: string,
    methodType: string,
    requestHeader: string,
    requestBody: string,
    urlParams: string,
    servicePath: string
): IDataServiceRequest {
    const query = vSIGetRestAPIResponseQuery();
    return query.createDataServiceRequestForOperation(
        'VSI_CallGenericRestAPIHandler',
        true,
        DataServiceEntities.VSIRestAPIHandlerExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IVSIRestAPIHandler' },
        {
            targetSystem: targetSystem,
            methodType: methodType,
            requestHeader: requestHeader,
            requestBody: requestBody,
            urlParams: urlParams,
            servicePath: servicePath
        }
    );
}

export function vSI_CallGenericRestAPIHandlerAsync(
    context: IContext,
    targetSystem: string,
    methodType: string,
    requestHeader: string,
    requestBody: string,
    urlParams: string,
    servicePath: string
): AsyncResult<DataServiceEntities.IVSIRestAPIHandler> {
    const request = createVSI_CallGenericRestAPIHandlerInput(targetSystem, methodType, requestHeader, requestBody, urlParams, servicePath);
    return callActionOrExecute<DataServiceEntities.IVSIRestAPIHandler>(request, context.callerContext);
}

export function createVSI_AddPorductInterestInput(
    customerId: string,
    customerEmailAddress: string,
    productCode: string,
    quantity: string,
    emailSent: boolean,
    company: string,
    productCodeRefRecId: number
): IDataServiceRequest {
    const query = vSIGetRestAPIResponseQuery();
    return query.createDataServiceRequestForOperation(
        'VSI_AddPorductInterest',
        true,
        DataServiceEntities.VSIBackinStockResponseExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IVSIBackinStockResponse' },
        {
            customerId: customerId,
            customerEmailAddress: customerEmailAddress,
            productCode: productCode,
            quantity: quantity,
            emailSent: emailSent,
            company: company,
            productCodeRefRecId: productCodeRefRecId
        }
    );
}

export function vSI_AddPorductInterestAsync(
    context: IContext,
    customerId: string,
    customerEmailAddress: string,
    productCode: string,
    quantity: string,
    emailSent: boolean,
    company: string,
    productCodeRefRecId: number
): AsyncResult<DataServiceEntities.IVSIBackinStockResponse> {
    const request = createVSI_AddPorductInterestInput(
        customerId,
        customerEmailAddress,
        productCode,
        quantity,
        emailSent,
        company,
        productCodeRefRecId
    );
    return callActionOrExecute<DataServiceEntities.IVSIBackinStockResponse>(request, context.callerContext);
}

export function createVSI_GetNoOfTransactionsInput(itemID: string, noOfHours: number, company: string): IDataServiceRequest {
    const query = vSIGetRestAPIResponseQuery();
    return query.createDataServiceRequestForOperation(
        'VSI_GetNoOfTransactions',
        true,
        DataServiceEntities.VSINoOfTransactionsResponseExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IVSINoOfTransactionsResponse' },
        { ItemID: itemID, NoOfHours: noOfHours, Company: company }
    );
}

export function vSI_GetNoOfTransactionsAsync(
    context: IContext,
    itemID: string,
    noOfHours: number,
    company: string
): AsyncResult<DataServiceEntities.IVSINoOfTransactionsResponse> {
    const request = createVSI_GetNoOfTransactionsInput(itemID, noOfHours, company);
    return callActionOrExecute<DataServiceEntities.IVSINoOfTransactionsResponse>(request, context.callerContext);
}

export function createVSI_GetDiscountInfoInput(
    queryResultSettings: IQueryResultSettings,
    productID: string[],
    periodicDiscountType: string
): IDataServiceRequest {
    const query = vSIGetRestAPIResponseQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation(
        'VSI_GetDiscountInfo',
        true,
        DataServiceEntities.VSIDiscountInfoExtensionClass,
        'true',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IVSIDiscountInfo' },
        { ProductID: productID, PeriodicDiscountType: periodicDiscountType }
    );
}

export function vSI_GetDiscountInfoAsync(
    context: IContext,
    productID: string[],
    periodicDiscountType: string
): AsyncResult<DataServiceEntities.IVSIDiscountInfo[]> {
    const request = createVSI_GetDiscountInfoInput(context.queryResultSettings || {}, productID, periodicDiscountType);
    return callActionOrExecute<DataServiceEntities.IVSIDiscountInfo[]>(request, context.callerContext);
}

// @ts-ignore
function vSIRemoveChargesQuery(id?: number): DataServiceQuery {
    const key = id ? { Id: id } : null;
    return new DataServiceQuery(
        'VSIRemoveCharges',
        'VSIRestAPIHandlerCharges',
        DataServiceEntities.VSIRestAPIHandlerChargesExtensionClass,
        key
    );
}
